export default {
  deleteUserResponseSuccessMsg: "Survey response deleted successfully",
  deleteUserResponseFailedMsg: "Deleting survey response failed",
};
